module.exports = __webpack_public_path__ + "media/images/mypage/btn07_ov-3c3c1b31291ec784002042894b2efc05.gif";